export var selectTooltipAxisId = state => state.tooltip.settings.axisId;